module.exports = __webpack_public_path__ + "img/6_5.714899f7.png";